import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Sequential from './Sequential';
import ClientProvider from './client';
export default createDemo(import.meta.url, Sequential, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/masonry/demos/sequential/Sequential.tsx",
    "fileName": "Sequential.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\nimport Paper from '@mui/material/Paper';\nimport Masonry from '@mui/lab/Masonry';\n\nconst heights = [150, 30, 90, 70, 110, 150, 130, 80, 50, 90, 100, 150, 30, 50, 80];\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(0.5),\n  textAlign: 'center',\n  color: (theme.vars || theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function Sequential() {\n  return (\n    <Box sx={{ width: 500, minHeight: 393 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Masonry\n        columns={4}\n        spacing={2}\n        defaultHeight={480}\n        defaultColumns={4}\n        defaultSpacing={2}\n        sequential\n      >\n        {heights.map((height, index) => (\n          <Item key={index} sx={{ height }}>\n            {index + 1}\n          </Item>\n        ))}\n      </Masonry>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 38,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport { styled } from '@mui/material/styles';\nimport Paper from '@mui/material/Paper';\nimport Masonry from '@mui/lab/Masonry';\n\nconst heights = [150, 30, 90, 70, 110, 150, 130, 80, 50, 90, 100, 150, 30, 50, 80];\n\nconst Item = styled(Paper)(({ theme }) => ({\n  backgroundColor: '#fff',\n  ...theme.typography.body2,\n  padding: theme.spacing(0.5),\n  textAlign: 'center',\n  color: (theme.vars || theme).palette.text.secondary,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#1A2027',\n  }),\n}));\n\nexport default function Sequential() {\n  return (\n    <Box sx={{ width: 500, minHeight: 393 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Masonry\n        columns={4}\n        spacing={2}\n        defaultHeight={480}\n        defaultColumns={4}\n        defaultSpacing={2}\n        sequential\n      >\n        {heights.map((height, index) => (\n          <Item key={index} sx={{ height }}>\n            {index + 1}\n          </Item>\n        ))}\n      </Masonry>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Masonry"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "columns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "spacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultHeight"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "480"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultColumns"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "defaultSpacing"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "sequential"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "heights"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "height"
              ],
              ", ",
              [
                "span",
                "pl-v",
                "index"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "index"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "pl-smi di-jv",
                "height"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "            ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "index"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "+"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Masonry"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 38,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/styles",
      "@mui/material/Paper",
      "@mui/lab/Masonry"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
